export enum Country {
  Switzerland = 'CH',
  Others = 'XX',
}
